var map = {
	"./alarm-fill.svg": "2f25",
	"./alarm.svg": "c3bd",
	"./alt.svg": "c9d8",
	"./app-indicator.svg": "73e7",
	"./app.svg": "33c2",
	"./archive-fill.svg": "f833",
	"./archive.svg": "8238",
	"./arrow-90deg-down.svg": "e758",
	"./arrow-90deg-left.svg": "33c7",
	"./arrow-90deg-right.svg": "24df",
	"./arrow-90deg-up.svg": "9190",
	"./arrow-bar-down.svg": "0318",
	"./arrow-bar-left.svg": "f2c8",
	"./arrow-bar-right.svg": "027d",
	"./arrow-bar-up.svg": "c6a9",
	"./arrow-clockwise.svg": "2091",
	"./arrow-counterclockwise.svg": "a498",
	"./arrow-down-circle-fill.svg": "045b",
	"./arrow-down-circle.svg": "32cb",
	"./arrow-down-left-circle-fill.svg": "a130",
	"./arrow-down-left-circle.svg": "f940",
	"./arrow-down-left-square-fill.svg": "2dfe",
	"./arrow-down-left-square.svg": "db37",
	"./arrow-down-left.svg": "eb08",
	"./arrow-down-right-circle-fill.svg": "3306",
	"./arrow-down-right-circle.svg": "8079",
	"./arrow-down-right-square-fill.svg": "f8fa",
	"./arrow-down-right-square.svg": "30b2",
	"./arrow-down-right.svg": "5f8e",
	"./arrow-down-short.svg": "75d6",
	"./arrow-down-square-fill.svg": "acbf",
	"./arrow-down-square.svg": "9ea8",
	"./arrow-down-up.svg": "d043",
	"./arrow-down.svg": "c874",
	"./arrow-left-circle-fill.svg": "d04d",
	"./arrow-left-circle.svg": "cbf7",
	"./arrow-left-right.svg": "498f",
	"./arrow-left-short.svg": "cf09",
	"./arrow-left-square-fill.svg": "0dd9",
	"./arrow-left-square.svg": "f9d8",
	"./arrow-left.svg": "ac3b",
	"./arrow-repeat.svg": "3ab5",
	"./arrow-return-left.svg": "63ea",
	"./arrow-return-right.svg": "8365",
	"./arrow-right-circle-fill.svg": "92da",
	"./arrow-right-circle.svg": "70be",
	"./arrow-right-short.svg": "c02d",
	"./arrow-right-square-fill.svg": "9cac",
	"./arrow-right-square.svg": "3864",
	"./arrow-right.svg": "cd8c",
	"./arrow-up-circle-fill.svg": "5ae8",
	"./arrow-up-circle.svg": "c88e",
	"./arrow-up-left-circle-fill.svg": "df4a",
	"./arrow-up-left-circle.svg": "c73b",
	"./arrow-up-left-square-fill.svg": "2b23",
	"./arrow-up-left-square.svg": "b7a9",
	"./arrow-up-left.svg": "320c",
	"./arrow-up-right-circle-fill.svg": "fe0b",
	"./arrow-up-right-circle.svg": "06f8",
	"./arrow-up-right-square-fill.svg": "2303",
	"./arrow-up-right-square.svg": "6df0",
	"./arrow-up-right.svg": "b137",
	"./arrow-up-short.svg": "ea53",
	"./arrow-up-square-fill.svg": "4687",
	"./arrow-up-square.svg": "26c9",
	"./arrow-up.svg": "a3f8",
	"./arrows-angle-contract.svg": "ca8e",
	"./arrows-angle-expand.svg": "cd9c",
	"./arrows-collapse.svg": "765a",
	"./arrows-expand.svg": "0f34",
	"./arrows-fullscreen.svg": "6868",
	"./arrows-move.svg": "2e40",
	"./aspect-ratio-fill.svg": "e143",
	"./aspect-ratio.svg": "f407",
	"./asterisk.svg": "b68a",
	"./at.svg": "a986",
	"./award-fill.svg": "5568",
	"./award.svg": "d815",
	"./backspace-fill.svg": "3e5c",
	"./backspace-reverse-fill.svg": "7e31",
	"./backspace-reverse.svg": "daf5",
	"./backspace.svg": "8e89",
	"./bag-check.svg": "cc22",
	"./bag-dash.svg": "3cc6",
	"./bag-fill.svg": "3f96",
	"./bag-plus.svg": "5435",
	"./bag.svg": "47fd",
	"./bar-chart-fill.svg": "3bc3",
	"./bar-chart.svg": "bde4",
	"./basket-fill.svg": "4210",
	"./basket.svg": "382e",
	"./basket2-fill.svg": "be32",
	"./basket2.svg": "4a7d",
	"./basket3-fill.svg": "43ae",
	"./basket3.svg": "b937",
	"./battery-charging.svg": "cc3c",
	"./battery-full.svg": "8bf9",
	"./battery-half.svg": "17b1",
	"./battery.svg": "e74d",
	"./bell-fill.svg": "cfd7",
	"./bell.svg": "3d56",
	"./blockquote-left.svg": "094e",
	"./blockquote-right.svg": "230f",
	"./book-half.svg": "203a",
	"./book.svg": "fc4e",
	"./bookmark-check.svg": "0abc",
	"./bookmark-dash.svg": "b2a4",
	"./bookmark-fill.svg": "7e3b",
	"./bookmark-plus.svg": "0d8d",
	"./bookmark.svg": "7253",
	"./bookmarks-fill.svg": "1ab1",
	"./bookmarks.svg": "2587",
	"./bootstrap-fill.svg": "5fd2",
	"./bootstrap-reboot.svg": "d168",
	"./bootstrap.svg": "6ea5",
	"./bounding-box-circles.svg": "21bb",
	"./bounding-box.svg": "3201",
	"./box-arrow-down-left.svg": "fb4f",
	"./box-arrow-down-right.svg": "f029",
	"./box-arrow-down.svg": "ff6e",
	"./box-arrow-in-down-left.svg": "fc36",
	"./box-arrow-in-down-right.svg": "3347",
	"./box-arrow-in-down.svg": "2a9b",
	"./box-arrow-in-left.svg": "faea",
	"./box-arrow-in-right.svg": "9db5",
	"./box-arrow-in-up-left.svg": "1bad",
	"./box-arrow-in-up-right.svg": "d9c7",
	"./box-arrow-in-up.svg": "cd2d",
	"./box-arrow-left.svg": "2a98",
	"./box-arrow-right.svg": "6e50",
	"./box-arrow-up-left.svg": "854d",
	"./box-arrow-up-right.svg": "a3b8",
	"./box-arrow-up.svg": "d66e",
	"./box-seam.svg": "30b7",
	"./box.svg": "bb19",
	"./braces.svg": "0125",
	"./briefcase-fill.svg": "a589",
	"./briefcase.svg": "24c9",
	"./brightness-alt-high-fill.svg": "d4b3",
	"./brightness-alt-high.svg": "db8a",
	"./brightness-alt-low-fill.svg": "547c",
	"./brightness-alt-low.svg": "c7a6",
	"./brightness-high-fill.svg": "6f93",
	"./brightness-high.svg": "bf91",
	"./brightness-low-fill.svg": "4cba",
	"./brightness-low.svg": "cf06",
	"./brush.svg": "3f92",
	"./bucket-fill.svg": "3562",
	"./bucket.svg": "044f",
	"./building.svg": "a528",
	"./bullseye.svg": "8aac",
	"./calendar-check-fill.svg": "db17",
	"./calendar-check.svg": "2831",
	"./calendar-date-fill.svg": "0eb3",
	"./calendar-date.svg": "83ef",
	"./calendar-day-fill.svg": "b04e",
	"./calendar-day.svg": "4929",
	"./calendar-fill.svg": "563f",
	"./calendar-minus-fill.svg": "4c98",
	"./calendar-minus.svg": "3cd2",
	"./calendar-month-fill.svg": "72c0",
	"./calendar-month.svg": "e076",
	"./calendar-plus-fill.svg": "1bee",
	"./calendar-plus.svg": "b747",
	"./calendar.svg": "b8bd",
	"./calendar2-check-fill.svg": "f8a3",
	"./calendar2-check.svg": "a7be",
	"./calendar2-date-fill.svg": "2d2e",
	"./calendar2-date.svg": "e73d",
	"./calendar2-day-fill.svg": "c7ba",
	"./calendar2-day.svg": "fcef",
	"./calendar2-fill.svg": "4c2e",
	"./calendar2-minus-fill.svg": "75c9",
	"./calendar2-minus.svg": "8a4c",
	"./calendar2-month-fill.svg": "38cb",
	"./calendar2-month.svg": "ea53c",
	"./calendar2-plus-fill.svg": "006f",
	"./calendar2-plus.svg": "ad7a",
	"./calendar2.svg": "cdaa",
	"./calendar3-fill.svg": "b9db",
	"./calendar3.svg": "8ce1",
	"./calendar4.svg": "9789",
	"./camera-video-fill.svg": "b747b",
	"./camera-video-off-fill.svg": "63e9",
	"./camera-video-off.svg": "8931",
	"./camera-video.svg": "ea39",
	"./camera.svg": "24e5",
	"./capslock-fill.svg": "77e4",
	"./capslock.svg": "3686",
	"./card-checklist.svg": "a47f",
	"./card-heading.svg": "77ee",
	"./card-image.svg": "1678",
	"./card-list.svg": "1c61",
	"./card-text.svg": "d15d",
	"./caret-down-fill.svg": "03c3",
	"./caret-down-square-fill.svg": "8cec",
	"./caret-down-square.svg": "1c91",
	"./caret-down.svg": "3f24",
	"./caret-left-fill.svg": "a520",
	"./caret-left-square-fill.svg": "4938",
	"./caret-left-square.svg": "5f60",
	"./caret-left.svg": "eee7",
	"./caret-right-fill.svg": "cec4",
	"./caret-right-square-fill.svg": "fb99",
	"./caret-right-square.svg": "4306",
	"./caret-right.svg": "138f",
	"./caret-up-fill.svg": "7708",
	"./caret-up-square-fill.svg": "d8d2",
	"./caret-up-square.svg": "38ea",
	"./caret-up.svg": "2d60",
	"./cart-check.svg": "4aa2",
	"./cart-dash.svg": "18b1",
	"./cart-fill.svg": "963c",
	"./cart-plus.svg": "2b8b",
	"./cart.svg": "daca",
	"./cart2.svg": "da5c",
	"./cart3.svg": "af52",
	"./cart4.svg": "cd2df",
	"./chat-dots-fill.svg": "3433",
	"./chat-dots.svg": "b99f",
	"./chat-fill.svg": "c6c8",
	"./chat-quote-fill.svg": "bc3a",
	"./chat-quote.svg": "63f5",
	"./chat-square-dots-fill.svg": "96aa",
	"./chat-square-dots.svg": "4cc9",
	"./chat-square-fill.svg": "98b0",
	"./chat-square-quote-fill.svg": "a0a1",
	"./chat-square-quote.svg": "23ab",
	"./chat-square.svg": "280c",
	"./chat.svg": "9b69",
	"./check-all.svg": "faa1",
	"./check-circle-fill.svg": "1630",
	"./check-circle.svg": "cfcb",
	"./check-square-fill.svg": "f471",
	"./check-square.svg": "7367",
	"./check.svg": "7bae",
	"./check2-all.svg": "cb3b",
	"./check2-circle.svg": "6445",
	"./check2-square.svg": "1330",
	"./check2.svg": "9022",
	"./chevron-bar-contract.svg": "006ff",
	"./chevron-bar-down.svg": "373f",
	"./chevron-bar-expand.svg": "c09c",
	"./chevron-bar-left.svg": "defa",
	"./chevron-bar-right.svg": "2a8c",
	"./chevron-bar-up.svg": "0238",
	"./chevron-compact-down.svg": "227c",
	"./chevron-compact-left.svg": "8403",
	"./chevron-compact-right.svg": "4645",
	"./chevron-compact-up.svg": "12b1",
	"./chevron-contract.svg": "d553",
	"./chevron-double-down.svg": "61b0",
	"./chevron-double-left.svg": "c288",
	"./chevron-double-right.svg": "ae48",
	"./chevron-double-up.svg": "5e7c",
	"./chevron-down.svg": "1755",
	"./chevron-expand.svg": "e8f9",
	"./chevron-left.svg": "d0fe",
	"./chevron-right.svg": "88ee",
	"./chevron-up.svg": "bb5d",
	"./circle-fill.svg": "ef57",
	"./circle-half.svg": "d582",
	"./circle-square.svg": "8d1a",
	"./circle.svg": "b289",
	"./clipboard-data.svg": "cdea",
	"./clipboard.svg": "4247",
	"./clock-fill.svg": "a6b2",
	"./clock-history.svg": "69cb",
	"./clock.svg": "755b",
	"./cloud-download.svg": "fb05",
	"./cloud-fill.svg": "1589",
	"./cloud-slash-fill.svg": "7000",
	"./cloud-slash.svg": "01c6",
	"./cloud-upload.svg": "ecad",
	"./cloud.svg": "2b35",
	"./code-slash.svg": "c301",
	"./code.svg": "100a",
	"./collection-fill.svg": "c85c",
	"./collection-play-fill.svg": "6f22",
	"./collection-play.svg": "86e2",
	"./collection.svg": "3539",
	"./columns-gap.svg": "4535",
	"./columns.svg": "b6ee",
	"./command.svg": "870e",
	"./compass.svg": "7259",
	"./cone-striped.svg": "101e",
	"./cone.svg": "73a8",
	"./controller.svg": "792c",
	"./credit-card.svg": "98dc",
	"./crop.svg": "2269",
	"./cup.svg": "5e13",
	"./cursor-fill.svg": "50e8",
	"./cursor-text.svg": "fe82",
	"./cursor.svg": "22a7",
	"./dash-circle-fill.svg": "dcd3",
	"./dash-circle.svg": "692b",
	"./dash-square-fill.svg": "dce8",
	"./dash-square.svg": "34d4",
	"./dash.svg": "bfba",
	"./diamond-fill.svg": "d741",
	"./diamond-half.svg": "28e8",
	"./diamond.svg": "3daa",
	"./display-fill.svg": "1f5d",
	"./display.svg": "439c",
	"./door-closed-fill.svg": "00a8",
	"./door-closed.svg": "7d22",
	"./dot.svg": "6a22",
	"./download.svg": "f28e",
	"./droplet-fill.svg": "e7fe",
	"./droplet-half.svg": "b4cf",
	"./droplet.svg": "2003",
	"./egg-fill.svg": "a3e2",
	"./egg-fried.svg": "f9a4",
	"./egg.svg": "5227",
	"./eject-fill.svg": "3c05",
	"./eject.svg": "be0f",
	"./emoji-angry.svg": "990f",
	"./emoji-dizzy.svg": "aa95",
	"./emoji-frown.svg": "bd6a",
	"./emoji-laughing.svg": "cf2b",
	"./emoji-neutral.svg": "9bd9",
	"./emoji-smile-upside-down.svg": "70bf",
	"./emoji-smile.svg": "bae0",
	"./emoji-sunglasses.svg": "8cab",
	"./envelope-fill.svg": "5a9d",
	"./envelope-open-fill.svg": "0f4a",
	"./envelope-open.svg": "220c",
	"./envelope.svg": "8e29",
	"./exclamation-circle-fill.svg": "ce84",
	"./exclamation-circle.svg": "8128",
	"./exclamation-diamond-fill.svg": "3b17",
	"./exclamation-diamond.svg": "dc42",
	"./exclamation-octagon-fill.svg": "c69b",
	"./exclamation-octagon.svg": "3ac1",
	"./exclamation-square-fill.svg": "63d8",
	"./exclamation-square.svg": "c5b4",
	"./exclamation-triangle-fill.svg": "5896",
	"./exclamation-triangle.svg": "6339",
	"./exclamation.svg": "177c",
	"./exclude.svg": "c05a",
	"./eye-fill.svg": "b194",
	"./eye-slash-fill.svg": "dda4",
	"./eye-slash.svg": "905f",
	"./eye.svg": "7364",
	"./file-arrow-down.svg": "2428",
	"./file-arrow-up.svg": "850a",
	"./file-break.svg": "e576",
	"./file-check.svg": "153f",
	"./file-code.svg": "9889",
	"./file-diff.svg": "ff33",
	"./file-earmark-arrow-down.svg": "8148",
	"./file-earmark-arrow-up.svg": "22d6",
	"./file-earmark-break.svg": "0cc7",
	"./file-earmark-check.svg": "8673",
	"./file-earmark-code.svg": "9385",
	"./file-earmark-diff.svg": "5b49",
	"./file-earmark-minus.svg": "886f",
	"./file-earmark-plus.svg": "6377",
	"./file-earmark-ruled.svg": "0043",
	"./file-earmark-spreadsheet.svg": "4c87",
	"./file-earmark-text.svg": "2c04",
	"./file-earmark-zip.svg": "0630",
	"./file-earmark.svg": "789b",
	"./file-minus.svg": "ca38",
	"./file-plus.svg": "1f05",
	"./file-post.svg": "4b74",
	"./file-richtext.svg": "8f83",
	"./file-ruled.svg": "01b3",
	"./file-spreadsheet.svg": "584d",
	"./file-text.svg": "aac1",
	"./file-zip.svg": "92bd",
	"./file.svg": "a147",
	"./files-alt.svg": "9b93",
	"./files.svg": "d38b",
	"./film.svg": "0750",
	"./filter-left.svg": "4b4e",
	"./filter-right.svg": "c161",
	"./filter.svg": "2376",
	"./flag-fill.svg": "f0ca",
	"./flag.svg": "c26e",
	"./folder-check.svg": "0d37",
	"./folder-fill.svg": "0fe5",
	"./folder-minus.svg": "a509",
	"./folder-plus.svg": "c62f",
	"./folder-symlink-fill.svg": "9b5b",
	"./folder-symlink.svg": "d2b6",
	"./folder.svg": "383d",
	"./fonts.svg": "cc85",
	"./forward-fill.svg": "5d0b",
	"./forward.svg": "bdb1",
	"./fullscreen-exit.svg": "4679",
	"./fullscreen.svg": "379e",
	"./funnel-fill.svg": "f2ff",
	"./funnel.svg": "c929",
	"./gear-fill.svg": "5188",
	"./gear-wide-connected.svg": "b58d",
	"./gear-wide.svg": "b0ff",
	"./gear.svg": "f571",
	"./gem.svg": "f9b7",
	"./geo-alt.svg": "bc00",
	"./geo.svg": "7126",
	"./gift-fill.svg": "54e6",
	"./gift.svg": "fb5c",
	"./graph-down.svg": "3838",
	"./graph-up.svg": "426f",
	"./grid-1x2-fill.svg": "b36c",
	"./grid-1x2.svg": "5e90",
	"./grid-3x2-gap-fill.svg": "8ab9",
	"./grid-3x2-gap.svg": "dc43",
	"./grid-3x2.svg": "aeb7",
	"./grid-3x3-gap-fill.svg": "bc4b",
	"./grid-3x3-gap.svg": "5cdd",
	"./grid-3x3.svg": "ec08",
	"./grid-fill.svg": "50bf",
	"./grid.svg": "4b05",
	"./grip-horizontal.svg": "0b91",
	"./grip-vertical.svg": "01b2",
	"./hammer.svg": "7d6c",
	"./hand-index-thumb.svg": "c2eb",
	"./hand-index.svg": "a1c8",
	"./hand-thumbs-down.svg": "22fd",
	"./hand-thumbs-up.svg": "50f5",
	"./handbag-fill.svg": "f5d2",
	"./handbag.svg": "a6ef",
	"./hash.svg": "8316",
	"./headphones.svg": "1f3e",
	"./heart-fill.svg": "587a",
	"./heart-half.svg": "0ef6",
	"./heart.svg": "7d16",
	"./hexagon-fill.svg": "6517",
	"./hexagon-half.svg": "31b6",
	"./hexagon.svg": "1ea9",
	"./house-door-fill.svg": "53d7",
	"./house-door.svg": "1957",
	"./house-fill.svg": "b93c",
	"./house.svg": "750c",
	"./hr.svg": "3eaa",
	"./image-alt.svg": "b982",
	"./image-fill.svg": "5d56",
	"./image.svg": "931c",
	"./images.svg": "3d71",
	"./inbox-fill.svg": "9510",
	"./inbox.svg": "2a9f",
	"./inboxes-fill.svg": "0d65",
	"./inboxes.svg": "7581",
	"./info-circle-fill.svg": "089e",
	"./info-circle.svg": "6668",
	"./info-square-fill.svg": "ba46",
	"./info-square.svg": "8909",
	"./info.svg": "76ed",
	"./intersect.svg": "b335",
	"./justify-left.svg": "0a92",
	"./justify-right.svg": "a79e",
	"./justify.svg": "79a5",
	"./kanban-fill.svg": "dfd3",
	"./kanban.svg": "461c",
	"./laptop.svg": "cd06",
	"./layers-fill.svg": "daa8",
	"./layers-half.svg": "6e36",
	"./layers.svg": "626a",
	"./layout-sidebar-inset-reverse.svg": "bede",
	"./layout-sidebar-inset.svg": "c464",
	"./layout-sidebar-reverse.svg": "b2f4",
	"./layout-sidebar.svg": "4776",
	"./layout-split.svg": "4159",
	"./layout-text-sidebar-reverse.svg": "0dd0",
	"./layout-text-sidebar.svg": "f7b4",
	"./layout-text-window-reverse.svg": "8c09",
	"./layout-text-window.svg": "289f",
	"./layout-three-columns.svg": "8a40",
	"./layout-wtf.svg": "8a72",
	"./life-preserver.svg": "0e05",
	"./lightning-fill.svg": "913f",
	"./lightning.svg": "4ed0",
	"./link-45deg.svg": "33d3",
	"./link.svg": "40a1",
	"./list-check.svg": "672d",
	"./list-nested.svg": "d80d",
	"./list-ol.svg": "506d",
	"./list-task.svg": "6111",
	"./list-ul.svg": "4582",
	"./list.svg": "99ad",
	"./lock-fill.svg": "9801",
	"./lock.svg": "9619",
	"./map.svg": "0443",
	"./mic-fill.svg": "abf2",
	"./mic-mute-fill.svg": "9e69",
	"./mic-mute.svg": "bff1",
	"./mic.svg": "6366",
	"./minecart-loaded.svg": "ced5",
	"./minecart.svg": "5bd4",
	"./moon.svg": "0190",
	"./music-note-beamed.svg": "d663",
	"./music-note-list.svg": "395d",
	"./music-note.svg": "46e0",
	"./music-player-fill.svg": "de05",
	"./music-player.svg": "b8dc",
	"./newspaper.svg": "ae46",
	"./octagon-fill.svg": "684f",
	"./octagon-half.svg": "b099",
	"./octagon.svg": "f0d9",
	"./option.svg": "e75f",
	"./outlet.svg": "f8e0",
	"./paperclip.svg": "b308",
	"./pause-fill.svg": "39e7",
	"./pause.svg": "644b",
	"./pen.svg": "6492",
	"./pencil-square.svg": "abd3",
	"./pencil.svg": "e51f",
	"./pentagon-fill.svg": "33fa",
	"./pentagon-half.svg": "9745",
	"./pentagon.svg": "4053",
	"./people-fill.svg": "22f3",
	"./people.svg": "1a5b",
	"./person-bounding-box.svg": "944d",
	"./person-check-fill.svg": "bf26",
	"./person-check.svg": "2262",
	"./person-circle.svg": "dcfa",
	"./person-dash-fill.svg": "e294",
	"./person-dash.svg": "8e79",
	"./person-fill.svg": "46f5",
	"./person-lines-fill.svg": "56d5",
	"./person-plus-fill.svg": "615a",
	"./person-plus.svg": "4da1",
	"./person-square.svg": "c210",
	"./person.svg": "d104",
	"./phone-landscape.svg": "b060",
	"./phone.svg": "c3bb",
	"./pie-chart-fill.svg": "f309",
	"./pie-chart.svg": "9773",
	"./pip-fill.svg": "2fe6",
	"./pip.svg": "3143",
	"./play-fill.svg": "fbcf",
	"./play.svg": "dab1",
	"./plug.svg": "1758",
	"./plus-circle-fill.svg": "32f4",
	"./plus-circle.svg": "d99e",
	"./plus-square-fill.svg": "dafa",
	"./plus-square.svg": "0156",
	"./plus.svg": "eb38",
	"./power.svg": "111a",
	"./puzzle-fill.svg": "1588",
	"./puzzle.svg": "4b20",
	"./question-circle-fill.svg": "e7d6",
	"./question-circle.svg": "1f28",
	"./question-diamond-fill.svg": "312f",
	"./question-diamond.svg": "ab54",
	"./question-octagon-fill.svg": "078d",
	"./question-octagon.svg": "3603",
	"./question-square-fill.svg": "f0e1",
	"./question-square.svg": "5ed4",
	"./question.svg": "9872",
	"./receipt-cutoff.svg": "f34b",
	"./receipt.svg": "a5d7",
	"./reply-all-fill.svg": "1029",
	"./reply-all.svg": "fa09",
	"./reply-fill.svg": "c6b1",
	"./reply.svg": "8b9d",
	"./screwdriver.svg": "784f",
	"./search.svg": "d103",
	"./server.svg": "90f6",
	"./shield-fill.svg": "2b30",
	"./shield-lock-fill.svg": "86d6",
	"./shield-lock.svg": "a74d",
	"./shield-shaded.svg": "021f",
	"./shield-slash-fill.svg": "59d0",
	"./shield-slash.svg": "b3f0",
	"./shield.svg": "64fe",
	"./shift-fill.svg": "871e",
	"./shift.svg": "616e",
	"./shop-window.svg": "3c7e",
	"./shop.svg": "5747",
	"./shuffle.svg": "00e6",
	"./skip-backward-fill.svg": "31a0",
	"./skip-backward.svg": "8aca",
	"./skip-end-fill.svg": "d678",
	"./skip-end.svg": "4953",
	"./skip-forward-fill.svg": "b266",
	"./skip-forward.svg": "90e34",
	"./skip-start-fill.svg": "8f2e",
	"./skip-start.svg": "1709",
	"./slash-circle-fill.svg": "e4f4",
	"./slash-circle.svg": "6ed2",
	"./slash-square-fill.svg": "713e",
	"./slash-square.svg": "f129",
	"./slash.svg": "7ca8",
	"./sliders.svg": "ff3f",
	"./soundwave.svg": "9354",
	"./speaker.svg": "5989",
	"./square-fill.svg": "cec1",
	"./square-half.svg": "8f44",
	"./square.svg": "d8a7",
	"./star-fill.svg": "c0e7",
	"./star-half.svg": "f771",
	"./star.svg": "cc90",
	"./stop-fill.svg": "d986",
	"./stop.svg": "56b4",
	"./stopwatch-fill.svg": "c3a5",
	"./stopwatch.svg": "aac5",
	"./subtract.svg": "86d0",
	"./sun.svg": "3961",
	"./table.svg": "979b",
	"./tablet-landscape.svg": "6f59",
	"./tablet.svg": "a9e0",
	"./tag-fill.svg": "61b2",
	"./tag.svg": "81fd",
	"./terminal-fill.svg": "245c",
	"./terminal.svg": "e7bd",
	"./text-center.svg": "945e",
	"./text-indent-left.svg": "756f",
	"./text-indent-right.svg": "2e5e",
	"./text-left.svg": "91ae",
	"./text-right.svg": "d7d9",
	"./textarea-t.svg": "042a",
	"./textarea.svg": "e0ee",
	"./three-dots-vertical.svg": "b405",
	"./three-dots.svg": "0960",
	"./toggle-off.svg": "277d",
	"./toggle-on.svg": "faf7",
	"./toggles.svg": "2b57",
	"./tools.svg": "a035",
	"./trash-fill.svg": "b329",
	"./trash.svg": "af22",
	"./trash2-fill.svg": "a111",
	"./trash2.svg": "3623",
	"./triangle-fill.svg": "d361",
	"./triangle-half.svg": "7d66",
	"./triangle.svg": "a8fe",
	"./trophy.svg": "e6bc",
	"./truck-flatbed.svg": "8fbe",
	"./truck.svg": "e5ca",
	"./tv-fill.svg": "f35c",
	"./tv.svg": "e678",
	"./type-bold.svg": "1c06",
	"./type-h1.svg": "ca7a",
	"./type-h2.svg": "53e2",
	"./type-h3.svg": "8963",
	"./type-italic.svg": "c6c6",
	"./type-strikethrough.svg": "6d0f",
	"./type-underline.svg": "c492",
	"./type.svg": "fa90",
	"./union.svg": "f46c",
	"./unlock-fill.svg": "c939",
	"./unlock.svg": "d901",
	"./upc-scan.svg": "07dc",
	"./upc.svg": "9d66",
	"./upload.svg": "5a96",
	"./view-list.svg": "641c",
	"./view-stacked.svg": "36d5",
	"./volume-down-fill.svg": "9b7d",
	"./volume-down.svg": "a5bb",
	"./volume-mute-fill.svg": "f532",
	"./volume-mute.svg": "6a7b",
	"./volume-off-fill.svg": "b635",
	"./volume-off.svg": "3ec0",
	"./volume-up-fill.svg": "6bab",
	"./volume-up.svg": "3569",
	"./vr.svg": "5bb7",
	"./wallet.svg": "4f4a",
	"./wallet2.svg": "348e",
	"./watch.svg": "bacc",
	"./wifi.svg": "4351",
	"./window.svg": "ce9f",
	"./wrench.svg": "0cd0",
	"./x-circle-fill.svg": "7fd1",
	"./x-circle.svg": "2940",
	"./x-diamond-fill.svg": "7096",
	"./x-diamond.svg": "f91d",
	"./x-octagon-fill.svg": "cd97",
	"./x-octagon.svg": "7210",
	"./x-square-fill.svg": "1b86",
	"./x-square.svg": "1004",
	"./x.svg": "7387"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";